import AttributesCoVColorField from './AttributesCoVColorField'

export default AttributesCoVColorField
